import React, { useState } from "react";
import { Modal } from "semantic-ui-react";
import Form, { CustomFormFieldProps, CustomFormValidator } from "./Form";

type FormModalProps = {
  fields: CustomFormFieldProps[];
  onSubmit: (...args: any[]) => void;
  submitText?: string;
  modalHeader: string;
  modalTrigger: (onClick: () => any) => React.ReactElement;
  size?: "mini" | "tiny" | "small" | "large" | "fullscreen";
  validate?: CustomFormValidator;
  preFormContent?: React.ReactElement;
  postFormContent?: React.ReactElement;
  onClose?: (...args: any[]) => void;
  disabled?: boolean;
};

const FormModal = ({
  fields,
  onSubmit,
  submitText,
  modalHeader,
  modalTrigger,
  size,
  validate,
  preFormContent,
  postFormContent,
  onClose,
  disabled
}: FormModalProps) => {
  const [open, setOpen] = useState(false);
  const submitAndClose = (props: any) => {
    onSubmit(props);
    setOpen(false);
  };
  const handleClose = (props: any) => {
    if (onClose) {
      onClose(props);
    }
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      trigger={modalTrigger(() => setOpen(true))}
      closeIcon
      size={size}
      onClose={handleClose}
    >
      <Modal.Header>{modalHeader}</Modal.Header>
      <Modal.Content>
        {preFormContent}
        <Form
          fields={fields}
          onSubmit={submitAndClose}
          submitText={submitText}
          validate={validate}
          //@ts-ignore: Form doesn't have this prop
          disabled={disabled}
        />
        {postFormContent}
      </Modal.Content>
    </Modal>
  );
};

export default FormModal;
